import { useCallback } from 'react';
import { useLocation } from 'react-router';

import { useConfig } from '#/hooks/useConfig';
import { Path } from '#/service/routes';
import { useAuthStore } from '#/store/auth/auth.store';

export const useUnauthenticatedHomePage = () => {
  const { isLoggedIn, isInitialised } = useAuthStore();
  const { featureConfig, pages } = useConfig();
  const { pathname } = useLocation();

  const isConfigured =
    !!featureConfig.unauthenticatedHomepage?.enabled &&
    !!pages.UNAUTHENTICATED_HOMEPAGE;

  const isLoading = isConfigured && !isInitialised && pathname === Path.Home;
  const shouldShow = isConfigured && isInitialised && !isLoggedIn;

  const pageId = pages.UNAUTHENTICATED_HOMEPAGE;

  const isUnauthenticatedHomePage = useCallback(
    (pageId: string) => shouldShow && pageId === pages.UNAUTHENTICATED_HOMEPAGE,
    [pages.UNAUTHENTICATED_HOMEPAGE, shouldShow]
  );

  return {
    isLoading,
    pageId,
    isUnauthenticatedHomePage,
    shouldShow,
  };
};
